module.exports = __webpack_public_path__ + "img/MDI-calendar-check.b7e8939a.svg";